<div style="text-align: center;">
<ion-button color="light" (click)="confirm(1)" style="min-width: 100px;" [color]="bizonylat == 1 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-invoice-96.png" width="50px">
    <span>Számla<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(2)" style="min-width: 100px;" [color]="bizonylat == 2 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-proforma-invoice-80.png" width="50px">
    <span>Előleg számla<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(3)" style="min-width: 100px;" [color]="bizonylat == 3 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-message-96.png" width="50px">
    <span>Díjbekérő<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(4)" style="min-width: 100px;" [color]="bizonylat == 4 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-receipt-96.png" width="50px">
    <span>Nyugta<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(5)" style="min-width: 100px;" [color]="bizonylat == 5 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-clipboard-96.png" width="50px">
    <span>Árajánlat<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(6)" style="min-width: 100px;" [color]="bizonylat == 6 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-delivery-96.png" width="50px">
    <span>Szállítólevél<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
<ion-button color="light" (click)="confirm(7)" style="min-width: 100px;" [color]="bizonylat == 7 ? 'primary':'light'">
  <div class="custom-button-content">
    <img src="assets/icon/icons8-task-completed-96.png" width="50px">
    <span>Teljesítésigazolás<br>
      <select name="nezet" style="visibility: hidden;">
        <option value="0">-</option>
      </select>
    </span>
  </div>
</ion-button>
</div>
<ion-grid>
  <form [formGroup]="formsz">
  <ion-row>

    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title>Kitől jön a bizonylat?</ion-card-title>
        </ion-card-header>
        <ion-card-content>
         
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-select aria-label="Profil" interface="popover" placeholder="" label="Profil"
                label-placement="stacked" fill="outline" value="0">
                <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Alapértelmezett</ion-select-option>
              </ion-select>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input label="Cégnév" formControlName="sintezmenyname" label-placement="stacked" fill="outline" placeholder="" readonly
                    ><ion-icon slot="start" name="apps" aria-hidden="true"></ion-icon></ion-input>
              </ion-col>
            </ion-row><ion-row>
              <ion-col>
                <ion-input label="Ország" label-placement="stacked" fill="outline" placeholder=""  formControlName="sorszag"
                  readonly ><ion-icon slot="start" name="globe" aria-hidden="true"></ion-icon></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              
                <ion-col size="4">
                  <ion-input label="Irányítószám" label-placement="stacked" fill="outline" placeholder=""  formControlName="sirsz"
                  readonly type="number"><ion-icon slot="start" name="apps" aria-hidden="true"></ion-icon></ion-input>
                </ion-col><ion-col>
                  <ion-input label="Település" label-placement="stacked" fill="outline" placeholder="" formControlName="stelepules"
                  readonly type="text"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
              <ion-col>
                  <ion-input label="Cím" label-placement="stacked" fill="outline" placeholder="" formControlName="scim"
                  readonly  type="text"><ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon></ion-input>
                </ion-col>
            
            </ion-row>
          </ion-grid>
      
        </ion-card-content>
      </ion-card>
    </ion-col>





    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title>Kinek szól a bizonylat?</ion-card-title>
        </ion-card-header>
        <ion-card-content>
      
          <ion-grid>
            <ion-row>
              <ion-col *ngIf="csalad?.users">
                <ion-select aria-label="Profil" interface="popover" placeholder="Válasszon profilt" label="Profil"
                label-placement="stacked" fill="outline" formControlName="kapja">
                <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
                <ion-select-option [value]="item.id" *ngFor="let item of csalad.users">{{item.nev}}</ion-select-option>
              </ion-select>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-select aria-label="Adózás" interface="popover" placeholder="" label="Adózás" readonly
                label-placement="stacked" fill="outline" value="1">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Adószámmal rendelkezik</ion-select-option>
                <ion-select-option value="1">Adószámmal nem rendelkezik</ion-select-option>
                <ion-select-option value="2">Külföldi</ion-select-option>
              </ion-select>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <div style="color:black"
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Ország</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Ország</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="globe" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="orszag" itemValueField="id" formControlName="orszag"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              </ion-col>
            </ion-row>
            <ion-row>
              
                <ion-col size="4">
                  <ion-input label="Irányítószám" label-placement="stacked" fill="outline" placeholder="" formControlName="irsz" readonly
                    type="number"><ion-icon slot="start" name="apps" aria-hidden="true"></ion-icon></ion-input>
                </ion-col><ion-col>
                  <ion-input label="Település" label-placement="stacked" fill="outline" placeholder="" formControlName="telepules" readonly
                    type="text"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
              <ion-col>
                  <ion-input label="Cím" label-placement="stacked" fill="outline" placeholder="" formControlName="cim" readonly
                    type="text"><ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon></ion-input>
                </ion-col>
            
            </ion-row>
          </ion-grid>
        
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>


  <ion-row>
    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title>Dátumok</ion-card-title>
        </ion-card-header>
        <ion-card-content>
         
          <ion-row>
            <ion-col>
              <ion-input label="Kelt" label-placement="stacked" fill="outline" placeholder="" type="date"
              max="3000-12-31" formControlName="kelt"><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input label="Teljesítés dátuma" label-placement="stacked" fill="outline" placeholder="" type="date"
              max="3000-12-31" formControlName="teljesites"><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input label="Fizetési határidő" label-placement="stacked" fill="outline" placeholder="" type="date"
              max="3000-12-31" formControlName="hatarido"><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
       
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>


  <ion-row *ngIf="formsz">
    
    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title>Fizetés</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          
          <ion-row>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Fizetési mód"
                formControlName="fizmod" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="1">Készpénz</ion-select-option>
                <ion-select-option value="2">Átutalás</ion-select-option>
                <ion-select-option value="3">Online bankkártya</ion-select-option>
                <ion-select-option value="4">Egyéb</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row><ion-row>
            <ion-col>
              <!--ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Online fizetési lehetőség"
                formControlName="onlinemod" label-placement="stacked" fill="outline" *ngIf="formsz.value.account">
                <ion-icon slot="start" name="card" aria-hidden="true"></ion-icon>
                <ion-select-option *ngFor="let item of formsz.value.account" value="1">Stripe</ion-select-option>
              </ion-select-->
              <ion-input [disabled]="true" value="Stripe" label="Online fizetési lehetőség" label-placement="stacked" fill="outline" ><ion-icon slot="start" name="time"
                aria-hidden="true" ></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Account"
                formControlName="account" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option *ngFor="let item of szamlaprofil.onlinefiz" [value]="item">{{item.name}}</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row><ion-row>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Bankszámlaszám"
                formControlName="bankszla" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option *ngFor="let item of szamlaprofil.bankszamla" [value]="item">{{item.bank}}: {{item.szam}} ({{item.deviza}})</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
        
        </ion-card-content>
      </ion-card>
    </ion-col>

    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title>Formátum</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <ion-row>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Bizonylattömb"
              formControlName="biztomb" label-placement="stacked" fill="outline">
              <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
              <ion-select-option value="ca6dca3d-fb62-11ef-9adc-0242ac120008">ZENIT</ion-select-option>
            </ion-select>
            </ion-col>
          </ion-row><ion-row>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Pénznem"
              formControlName="penznem" label-placement="stacked" fill="outline">
              <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
              <ion-select-option value="1">HUF</ion-select-option>
            </ion-select>
            </ion-col>
            <ion-col>
              <ion-input label="Árfolyam" label-placement="stacked" fill="outline" placeholder=""  formControlName="arfolyam"><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row><ion-row>
            <ion-col>
              <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Nyelv"
                formControlName="nyelv" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="1">Magyar</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>


</form>
  <ion-row>
    <ion-col>
      <ion-card >
        <ion-card-header>
          <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Tételek - Összesen: {{formsz.value.osszesen}} Ft</span>
            <ion-button style="float:right;" size="small" color="light" (click)="loadFromEgyenleg()">
              <ion-icon slot="start" name="download"></ion-icon>Importálás egyenlegből
            </ion-button><ion-button style="float:right;" size="small" color="secondary" (click)="addTetel()">
              <ion-icon slot="start" name="add"></ion-icon>Új tétel
            </ion-button></ion-card-title>
        </ion-card-header>
        <ion-card-content style="margin:10px">
          
            <ng-container *ngFor="let item of tetelek; let idx = index">
          <ion-row>
            <ion-col>
              <ion-textarea label="Megnevezés" [(ngModel)]="tetelek[idx].nev" labelPlacement="stacked" fill="outline" placeholder=""></ion-textarea>
            </ion-col>
            <ion-col>
              <ion-input label="Br. Egységár (Forint)" (ionChange)="calculateOsszesen()" [(ngModel)]="tetelek[idx].osszeg" label-placement="stacked" fill="outline" placeholder="" type="number"
              ><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon>
              </ion-input>
            </ion-col>
            <ion-col>
              <ion-select aria-label="ÁFA" interface="popover" placeholder="" label="ÁFA" [(ngModel)]="tetelek[idx].afa"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="AAM">AAM</ion-select-option>
                <ion-select-option value="27">27%</ion-select-option>
                <ion-select-option value="15">15%</ion-select-option>
                <ion-select-option value="8">8%</ion-select-option>
                <ion-select-option value="0">0%</ion-select-option>
                <ion-select-option value="TAM">TAM</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col>
              <ion-input label="Mennyiség" label-placement="stacked" fill="outline" placeholder="" type="number" [(ngModel)]="tetelek[idx].mennyiseg"
               ><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input label="M. egység" label-placement="stacked" fill="outline" placeholder="" type="text" [(ngModel)]="tetelek[idx].megyseg"
               ><ion-icon slot="start" name="time"
                aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-label>Br. részösszeg</ion-label><br>
    <ion-badge color="primary">{{tetelek[idx].osszeg}} Ft</ion-badge>
            </ion-col>
            <ion-col>
              <ion-button color="danger" size="small" style="margin-top:0" (click)="deleteTetel(idx)">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
            </ion-col>
          </ion-row>
          <hr style="border-bottom: 1px solid black;">
        </ng-container>
       
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

<ion-row>
  <ion-col>
    <ion-button (click)="save()">Mentés</ion-button>
  </ion-col>
</ion-row>

</ion-grid>



